import {createContext} from 'react';
import useDropdown from './hooks/useDropdown';

const DropdownContext = createContext<ReturnType<typeof useDropdown>>({
    blurInput: () => {},
    focusInput: () => {},
    hasClearSelection: false,
    isLoading: false,
    isMultiChoices: false,
    isOptionSelected: () => false,
    isSearchable: false,
    isShown: false,
    onClickClearSelection: () => {},
    onClickField: () => {},
    onClickOption: () => {},
    onUserKeyPress: () => {},
    options: [],
    refDrawer: {current: null},
    refField: {current: null},
    searchQuery: '',
    searchQueryDebounced: '',
    selectedOptions: [],
    setIsShown: () => {},
    setSearchQuery: () => {},
    setTooltipRef: () => {},
    type: 'select',
    value: '',
});

export default DropdownContext;
